import { render, staticRenderFns } from "./chanPinList.vue?vue&type=template&id=37069fc0&scoped=true&"
import script from "./chanPinList.vue?vue&type=script&lang=js&"
export * from "./chanPinList.vue?vue&type=script&lang=js&"
import style0 from "./chanPinList.vue?vue&type=style&index=0&id=37069fc0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37069fc0",
  null
  
)

export default component.exports